var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useGetModuleListQuery, useGetRemindersAllInviteesQuery, useSaveRecordMutation, } from "@/store/api";
import { LoaderImage } from "@/utils/loader";
import { faUsers } from "@fortawesome/pro-regular-svg-icons";
import { faBahai, faContactBook } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "@mui/joy";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
export default function SchedulerInvites(_a) {
    var _this = this;
    var updateInvitees = _a.updateInvitees, record = _a.record, module = _a.module;
    var t = useTranslation(["common", "Meetings"]).t;
    var defaultSearch = {
        last_name: "",
        first_name: "",
        email1: "",
    };
    var _b = useState(defaultSearch), searchParams = _b[0], setSearchparams = _b[1];
    var _c = useState([]), searchResult = _c[0], setSearchResult = _c[1];
    var _d = useState([]), newInvites = _d[0], setNewInvites = _d[1];
    var _e = useState({}), where = _e[0], setWhere = _e[1];
    var _f = useState(true), isSearched = _f[0], setIsSearched = _f[1];
    var _g = useState(false), isFromSearch = _g[0], setIsFromSearch = _g[1];
    var _h = useGetModuleListQuery({
        table: "Users",
        params: {
            where: where,
            page: 0,
            pageSize: 10,
            count: false,
        },
    }, { skip: isSearched }), usersList = _h.data, loaduser = _h.isLoading;
    var _j = useGetModuleListQuery({
        table: "Contacts",
        params: {
            where: where,
            page: 0,
            pageSize: 10,
            count: false,
        },
    }, { skip: isSearched }), contactsList = _j.data, loadcontact = _j.isLoading;
    var _k = useGetModuleListQuery({
        table: "Leads",
        params: {
            where: where,
            page: 0,
            pageSize: 10,
            count: false,
        },
    }, { skip: isSearched }), leadsList = _k.data, loadlead = _k.isLoading;
    useEffect(function () {
        var dataUsers = usersList === null || usersList === void 0 ? void 0 : usersList.data;
        var recordsUsers = (dataUsers === null || dataUsers === void 0 ? void 0 : dataUsers.records) || [];
        var dataContacts = contactsList === null || contactsList === void 0 ? void 0 : contactsList.data;
        var recordsContacts = (dataContacts === null || dataContacts === void 0 ? void 0 : dataContacts.records) || [];
        var dataLeads = leadsList === null || leadsList === void 0 ? void 0 : leadsList.data;
        var recordsLeads = (dataLeads === null || dataLeads === void 0 ? void 0 : dataLeads.records) || [];
        var array1 = recordsUsers.concat(recordsContacts);
        var array2 = array1.concat(recordsLeads);
        setSearchResult(array2.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        }));
    }, [usersList, contactsList, leadsList]);
    var setWhereValue = function (rule) {
        var r = [];
        Object.entries(rule).map(function (item) {
            item !== "" &&
                ["first_name", "last_name", "email1"].includes(item[0]) &&
                r.push({
                    field: item[0],
                    operator: "contains",
                    value: item[1],
                });
        });
        var whereVal = [
            {
                operator: "and",
                rules: r,
            },
        ];
        return whereVal;
    };
    var updateSearch = function (event) {
        var w = setWhereValue(searchParams);
        setIsFromSearch(true);
        setWhere(w);
        setIsSearched(false);
    };
    useEffect(function () {
        updateInvitees(newInvites);
    }, [newInvites]);
    var recordId = (record === null || record === void 0 ? void 0 : record.id) || "";
    var allInvitesResponse = useGetRemindersAllInviteesQuery({
        moduleName: module || "Meetings",
        recordId: recordId,
    }).data;
    useEffect(function () {
        (allInvitesResponse === null || allInvitesResponse === void 0 ? void 0 : allInvitesResponse.data) &&
            setNewInvites(allInvitesResponse === null || allInvitesResponse === void 0 ? void 0 : allInvitesResponse.data.allInvitees);
    }, [allInvitesResponse]);
    // Création invité contact ou lead
    var _l = useState(false), showForm = _l[0], setShowForm = _l[1];
    var _m = useState("Contacts"), invitedModule = _m[0], setInvitedModule = _m[1];
    var _o = useSaveRecordMutation(), saveRecordMutaion = _o[0], loadInviteeCreation = _o[1].isLoading;
    var initialRecord = {
        id: "",
        name: "",
        last_name: "",
        first_name: "",
        email1: "",
    };
    var _p = useState(initialRecord), editedRecord = _p[0], setEditedRecord = _p[1];
    var saveForm = function (mod, sendInvites) {
        if (sendInvites === void 0) { sendInvites = 0; }
        return __awaiter(_this, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, saveRecordMutaion({
                                body: {
                                    module: mod,
                                    record: editedRecord,
                                    relatedModuleName: module,
                                    relatedId: recordId,
                                    sendInvites: sendInvites,
                                } || {},
                            }).unwrap()];
                    case 1:
                        result = _a.sent();
                        toast.success("Invité crée avec succès");
                        setEditedRecord(initialRecord);
                        setShowForm(false);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    useEffect(function () {
        setEditedRecord(__assign(__assign({}, editedRecord), { name: editedRecord.first_name + " " + editedRecord.last_name }));
    }, [editedRecord.last_name, editedRecord.first_name]);
    var _q = useState(true), disabledBtn = _q[0], setDisabledBtn = _q[1];
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "bg-[var(--colors-body-bg-sec)] py-2 mt-6 text-[var(--colors-label)]" }, { children: [_jsx("div", __assign({ className: "m-4 bg-[var(--colors-body-bg)] p-2 rounded-md shadow sm:p-4" }, { children: _jsxs("div", __assign({ className: "schedulerInvitees" }, { children: [_jsx("h3", __assign({ className: "border-b-2 uppercase font-bold" }, { children: "Liste des invit\u00E9es \u00E0 ajouter" })), _jsx("div", __assign({ style: {
                                    overflow: "auto",
                                    width: "100%",
                                    height: "100%",
                                    display: "block",
                                } }, { children: newInvites && newInvites.length > 0 && (_jsx("table", __assign({ width: "100%", className: "my-4" }, { children: _jsx("tbody", { children: _jsx(_Fragment, { children: newInvites &&
                                                newInvites.map(function (record, index) { return (_jsxs("tr", __assign({ className: "" }, { children: [_jsxs("td", { children: [_jsxs("span", __assign({ className: "mr-2 text-gray-400" }, { children: [record.module_name === "Users" && (_jsx(FontAwesomeIcon, { icon: faUsers })), record.module_name === "Contacts" && (_jsx(FontAwesomeIcon, { icon: faContactBook })), record.module_name === "Leads" && (_jsx(FontAwesomeIcon, { icon: faBahai }))] })), record === null || record === void 0 ? void 0 : record.name] }), _jsx("td", { children: record === null || record === void 0 ? void 0 : record.email1 }), _jsx("td", { children: record === null || record === void 0 ? void 0 : record.phone_mobile }), _jsx("td", __assign({ align: "right" }, { children: _jsx("input", { type: "button", className: "button danger", value: "Supprimer", onClick: function (e) {
                                                                    var newTempInvites = newInvites.filter(function (item, i) {
                                                                        return i === index;
                                                                    });
                                                                    setSearchResult(__spreadArray(__spreadArray([], searchResult, true), [
                                                                        newTempInvites[0],
                                                                    ], false));
                                                                    var newInvitee = newInvites.filter(function (item, i) {
                                                                        return i !== index;
                                                                    });
                                                                    setNewInvites(newInvitee);
                                                                } }) }))] }), index)); }) }) }) }))) }))] })) })), _jsxs("div", __assign({ className: "m-4 bg-[var(--colors-body-bg)] p-2 rounded-md shadow sm:p-4 relative" }, { children: [(loadcontact || loadlead || loaduser || loadInviteeCreation) && (_jsx(LoaderImage, {})), _jsxs("div", __assign({ className: "schedulerInvitees" }, { children: [_jsx("h3", __assign({ className: "border-b-2 uppercase font-bold" }, { children: "Ajouter des participants" })), _jsx("table", __assign({ className: "mt-8 ", width: "100%" }, { children: _jsx("tbody", { children: _jsx("tr", { children: _jsx("td", { children: _jsx("table", __assign({ width: "100%" }, { children: _jsx("tbody", { children: _jsxs("tr", __assign({ className: "flex flex-row justify-between mb-4" }, { children: [_jsxs("td", { children: [_jsx("label", { children: "Pr\u00E9nom:\u00A0\u00A0" }), _jsx(Input, { name: "search_first_name", id: "search_first_name", value: searchParams.first_name, type: "text", onChange: function (e) {
                                                                                setSearchparams(__assign(__assign({}, searchParams), { first_name: e.target.value }));
                                                                            } })] }), _jsxs("td", { children: [_jsx("label", { children: "Nom:\u00A0\u00A0" }), _jsx(Input, { name: "search_last_name", id: "search_last_name", value: searchParams.last_name, type: "text", onChange: function (e) {
                                                                                setSearchparams(__assign(__assign({}, searchParams), { last_name: e.target.value }));
                                                                            } })] }), _jsxs("td", { children: [_jsx("label", { children: "Emails:\u00A0\u00A0" }), _jsx(Input, { name: "search_email", id: "search_email", value: searchParams.email1, type: "text", onChange: function (e) {
                                                                                setSearchparams(__assign(__assign({}, searchParams), { email1: e.target.value }));
                                                                            } })] }), _jsx("td", { children: _jsx("button", __assign({ className: "button primary mt-6", id: "invitees_search", onClick: function (e) {
                                                                            updateSearch(e);
                                                                        } }, { children: "Rechercher" })) })] })) }) })) }) }) }) }))] })), _jsxs("div", __assign({ style: {
                                overflow: "auto",
                                width: "100%",
                                height: "100%",
                                display: "block",
                            } }, { children: [searchResult && searchResult.length > 0 && (_jsx("table", __assign({ width: "100%", className: "my-4" }, { children: _jsxs("tbody", { children: [_jsxs("tr", __assign({ className: "bg-gray-300" }, { children: [_jsx("th", __assign({ className: "text-start" }, { children: "Nom" })), _jsx("th", __assign({ className: "text-start" }, { children: "Emails" })), _jsx("th", __assign({ className: "text-start" }, { children: "T\u00E9l\u00E9phone" })), _jsx("th", { children: "\u00A0" })] })), _jsx(_Fragment, { children: searchResult &&
                                                    searchResult.map(function (record, index) { return (_jsxs("tr", __assign({ className: "" }, { children: [_jsxs("td", { children: [_jsxs("span", __assign({ className: "mr-2 text-gray-400" }, { children: [record.module_name === "Users" && (_jsx(FontAwesomeIcon, { icon: faUsers })), record.module_name === "Contacts" && (_jsx(FontAwesomeIcon, { icon: faContactBook })), record.module_name === "Leads" && (_jsx(FontAwesomeIcon, { icon: faBahai }))] })), record.name] }), _jsx("td", { children: record.email1 }), _jsx("td", { children: record.phone_mobile }), _jsx("td", __assign({ align: "right" }, { children: _jsx("input", { type: "button", className: "button", value: "Ajouter", onClick: function (e) {
                                                                        var newTempInvites = searchResult.filter(function (item, i) {
                                                                            return i === index;
                                                                        });
                                                                        setNewInvites(__spreadArray(__spreadArray([], newInvites, true), [
                                                                            newTempInvites[0],
                                                                        ], false));
                                                                        var newInvitee = searchResult.filter(function (item, i) {
                                                                            return i !== index;
                                                                        });
                                                                        setSearchResult(newInvitee);
                                                                    } }) }))] }), index)); }) })] }) }))), searchResult && searchResult.length === 0 && isFromSearch && (_jsx("div", __assign({ className: "text-blue-400" }, { children: "D\u00E9sol\u00E9, aucun r\u00E9sultat trouv\u00E9. Veuillez cr\u00E9er un invit\u00E9 ci-dessous." }))), _jsxs("div", { children: [_jsx("span", __assign({ className: "uppercase" }, { children: t("LBL_CREATE_INVITEE", { ns: "Meetings" }) })), !showForm && (_jsxs("div", __assign({ className: "mt-4 flex flex-row" }, { children: [_jsx("button", __assign({ className: "button", onClick: function (e) {
                                                        setShowForm(true);
                                                        setInvitedModule("Contacts");
                                                        setEditedRecord(initialRecord);
                                                    } }, { children: t("LBL_CREATE_CONTACT", { ns: "Meetings" }) })), _jsx("button", __assign({ className: "button ml-4", onClick: function (e) {
                                                        setShowForm(true);
                                                        setInvitedModule("Leads");
                                                        setEditedRecord(initialRecord);
                                                    } }, { children: t("LBL_CREATE_LEAD", { ns: "Meetings" }) }))] }))), showForm && (_jsxs("div", __assign({ className: "mt-4" }, { children: [_jsx("label", { children: "Pr\u00E9nom:\u00A0\u00A0" }), _jsxs("form", { children: [_jsx(Input, { name: "invitee_first_name", value: editedRecord.first_name, type: "text", onChange: function (e) {
                                                                console.log(editedRecord);
                                                                setEditedRecord(__assign(__assign({}, editedRecord), { first_name: e.target.value }));
                                                            } }), _jsx("label", { children: "Nom:\u00A0\u00A0" }), _jsx(Input, { name: "invitee_last_name", value: editedRecord.last_name, type: "email", onChange: function (e) {
                                                                e.target.value !== ""
                                                                    ? setDisabledBtn(false)
                                                                    : setDisabledBtn(true);
                                                                setEditedRecord(__assign(__assign({}, editedRecord), { last_name: e.target.value }));
                                                            } }), _jsx("label", { children: "Email:\u00A0\u00A0" }), _jsx(Input, { name: "invitee_email", value: editedRecord.email1, type: "email", onChange: function (e) {
                                                                setEditedRecord(__assign(__assign({}, editedRecord), { email1: e.target.value }));
                                                            } })] }), _jsxs("div", __assign({ className: "mt-4" }, { children: [_jsx("button", __assign({ className: "button ml-4 primary", style: { background: disabledBtn ? "#EEEEEE" : "" }, onClick: function (e) {
                                                                saveForm(invitedModule);
                                                            }, disabled: disabledBtn }, { children: t("LBL_CREATE_AND_ADD", { ns: "Meetings" }) })), _jsx("button", __assign({ className: "button ml-4 secondary", onClick: function (e) {
                                                                setShowForm(false);
                                                                setEditedRecord(initialRecord);
                                                            } }, { children: t("LBL_CANCEL_CREATE_INVITEE", { ns: "Meetings" }) }))] }))] })))] })] }))] }))] })) }));
}
